import React from 'react'
import invariant from 'invariant'

import {
  UserRoleEnumType,
  UserProjectOrganizationTypeEnumType,
} from '~/common/types/graphql'
import { useCurrentUserContext } from '~/views/contexts/CurrentUserContext'

interface ViewerAuthorizedProps {
  children?: React.ReactNode | ((authorized: boolean) => React.ReactNode)
  roles?: string[]
  excludeRoles?: string[]
  currentUserProjectContext?:
    | UserProjectOrganizationTypeEnumType
    | null
    | string
}

const ViewerAuthorized = ({
  children,
  roles = [],
  excludeRoles = [],
  currentUserProjectContext,
}: ViewerAuthorizedProps) => {
  const { currentUser } = useCurrentUserContext()
  let role = currentUser?.role || UserRoleEnumType.Observer

  // If the currentUserContext is not provider (e.g. customer/third_party)
  // they will always be a 'contributor' on the project
  if (currentUserProjectContext && currentUserProjectContext !== 'PROVIDER')
    role = UserRoleEnumType.Contributor

  const rolesExist = !!roles?.length
  const excludeRolesExist = !!excludeRoles?.length

  const conflict = rolesExist && excludeRolesExist

  invariant(
    !conflict,
    'cannot have roles and excludeRoles prop set on component ViewerAuthorized',
  )

  let authorized: boolean = false
  if (rolesExist) authorized = roles?.includes(role)
  else if (excludeRolesExist) authorized = !excludeRoles?.includes(role)

  if (typeof children === 'function') {
    return children(authorized)
  } else {
    return authorized ? children : null
  }
}

export default ViewerAuthorized
